import React, {useState, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import './Accordion.css';
import AccordionContext from './useAccordionContext';
import {MdEdit} from "react-icons/md";
import {Dialog, DialogContent, Tooltip} from "@mui/material";
import ObjectsGrid from "./ObjectsGrid";
import {useNavigate} from "react-router-dom";
import {AiOutlinePlus} from "react-icons/ai";

function Accordion({title, children, image,  isLogin, hasEditingButton= false, onEdit, hasGlobalInputFields, categoryId }) {
    const [isOpen, setIsOpen] = useState(false);
    const parentAccordion = useContext(AccordionContext);
    const [open, setOpen] = useState(false)
    const navigate = useNavigate();

    const openUrl = (url) => {
        if (url) {
            navigate(url);
        }

    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Space') {
            if (isLogin) {
                handleClickOpen();
            } else {
                setIsOpen(!isOpen);
            }
        }
    };

    useEffect(() => {
        if (!parentAccordion.isOpen) {
            setIsOpen(false);
        }
    }, [parentAccordion]);

    return (
        <AccordionContext.Provider value={{isOpen, toggle: setIsOpen}}>
            <div className="accordion">
                <div
                    className="accordion-header"
                    onClick={() => isLogin ? handleClickOpen() : setIsOpen(!isOpen)}
                    onKeyDown={handleKeyDown}
                    tabIndex={0}
                    aria-expanded={isOpen}
                    role="button"

                >
                    {image ? <img src={image} alt="" className="header-image"/> : null}
                    <span className={"accordion-title"}>
                        {title}
                    </span>
                    {hasEditingButton && (
                        <>
                            <Tooltip title={"სახელის შეცვლა"}>
                                <span>
                                    <MdEdit
                                        style={{marginLeft: '10px', fontSize: '30px', cursor: 'pointer'}}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onEdit && onEdit();
                                        }}
                                    />
                                </span>
                            </Tooltip>
                        </>
                    )}
                    {hasGlobalInputFields && (
                        <Tooltip title={"შესაყვანი ველის დამატება"}>
                                <span>
                                    <AiOutlinePlus
                                        style={{marginLeft: '10px', fontSize: '30px', cursor: 'pointer', marginRight: '10px', color: "#3872F2"}}
                                        onClick={() => {
                                            openUrl(`/dashboard/globalinputfields?id=${categoryId}`);
                                        }}
                                    />
                                </span>
                        </Tooltip>
                    )}

                </div>
                {!isLogin && (
                    <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                        <div className={'accordion-children'}>{children}</div>
                    </div>
                )}
                <div>

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="dialog-title"
                        fullWidth
                        maxWidth="lg"
                    >
                        <DialogContent>
                            <ObjectsGrid onClose={handleClose}/>
                        </DialogContent>
                    </Dialog>
                </div>
            </div>

        </AccordionContext.Provider>
    );
}

Accordion.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    image: PropTypes.string,
    accordionOrder: PropTypes.number,
    isLogin: PropTypes.bool,
    onEdit: PropTypes.func,
};

Accordion.defaultProps = {
    image: null,
    accordionOrder: 0,
    isLogin: false,
    onEdit: null,
};

export default Accordion;
